import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box } from '@mui/material';

import MlmuserDashboard from '../MlmuserDashboard';
import { getListAPI as getMlmuserList, getMlmuserInfoByPartneridAPI } from 'components/mlmuser/MlmuserAPI';
import { getMlmcreditInfoByPartneridAPI } from 'components/mlmcredit/MlmcreditAPI';
import { setMlmuserList, setMlmuserDashboardMlmuserList } from 'store/slice/DmpSlice';
import { setSelectedTab } from 'store/slice/EcomSlice';

import { openDrawer } from './../../../store/slice/MenuSlice';
import MlmcreditPageImpl from 'components/mlmcredit/page/MlmcreditPageImpl';
import MlmuserMyTeamPage from './MlmuserMyTeamPage';

export default function MlmuserPageImpl() {
    const dispatch = useDispatch();
    const { mlmuserList } = useSelector((state) => state.dmpslice);
    const { mlmUserObj } = useSelector((state) => state.ecomslice.mlm);
    const { selectedTab } = useSelector((state) => state.ecomslice.checkout);

    const getMlmuserListSuccess = useCallback((list) => {
        dispatch(setMlmuserList(list));
    }, [dispatch]);

    useEffect(() => {
        if (selectedTab !== 'MY-TEAM' && selectedTab !== 'CREDIT') {
            dispatch(setSelectedTab("MY-TEAM"));
        }
    }, [dispatch, selectedTab])

    useEffect(() => {
        dispatch(openDrawer(false));
        if (mlmUserObj?.userid) {
            getMlmuserInfoByPartneridAPI(mlmUserObj.userid, () => { }, getMlmuserListSuccess);
        }
    }, [mlmUserObj?.userid, dispatch, getMlmuserListSuccess]);

    useEffect(() => {
        if (mlmuserList) {
            dispatch(setMlmuserDashboardMlmuserList(mlmuserList));
        }
    }, [mlmuserList, dispatch])

    const handleTabClick = useCallback((clickedTab) => {
        console.log('Tab clicked:', clickedTab); // Debug log
        dispatch(setSelectedTab(clickedTab));
    }, [dispatch])

    // Memoize the rendered content to prevent unnecessary re-renders
    const tabContent = useMemo(() => {
        if (selectedTab === 'MY-TEAM') {
            return <MlmuserMyTeamPage />;
        }
        return <MlmcreditPageImpl />;
    }, [selectedTab]);

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Grid container lg={12} xs={12} justifyContent="space-between" alignItems="center" direction="row"
                sx={{ mt: 1, mb: 2 }}>
                <Grid container lg={4} xs={6} justifyContent="center"
                    sx={{
                        borderBottom: selectedTab === 'MY-TEAM' ? '2px solid #003a8c' : '2px solid transparent',
                        paddingBottom: 1,
                        cursor: 'pointer',
                        userSelect: 'none',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            opacity: 0.8
                        },
                        '&:active': {
                            opacity: 0.6
                        },
                        pointerEvents: 'auto'
                    }}
                    onClick={() => handleTabClick('MY-TEAM')}
                >
                    <Typography
                        variant={selectedTab === 'MY-TEAM' ? 'h4' : 'h5'}
                        color={selectedTab === 'MY-TEAM' ? 'primary.dark' : 'primary.darker'}
                        sx={{ pointerEvents: 'none' }}
                    >
                        My Team
                    </Typography>
                </Grid>
                <Grid container lg={4} xs={6} justifyContent="center"
                    sx={{
                        borderBottom: selectedTab === 'CREDIT' ? '2px solid #003a8c' : '2px solid transparent',
                        paddingBottom: 1,
                        cursor: 'pointer',
                        userSelect: 'none',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            opacity: 0.8
                        },
                        '&:active': {
                            opacity: 0.6
                        },
                        pointerEvents: 'auto'
                    }}
                    onClick={() => handleTabClick('CREDIT')}
                >
                    <Typography
                        variant={selectedTab === 'CREDIT' ? 'h4' : 'h5'}
                        color={selectedTab === 'CREDIT' ? 'primary.dark' : 'primary.darker'}
                        sx={{ pointerEvents: 'none' }}
                    >
                        Credit Summary
                    </Typography>
                </Grid>
            </Grid>
            <Box sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
                {tabContent}
            </Box>
        </Box>
    )
}
